module.exports = __webpack_public_path__ + "img/luxura_x7.min.03cd7cf8.svg";